export default {"src":"/_next/static/media/time.f9513a87.svg","height":20,"width":20};